import { ReactNode } from 'react';

import { cn } from '@lib/utils';

interface SectionProps {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export default function Section({
  className,
  children,
  ...props
}: SectionProps) {
  const baseClassName = 'h-[720px] flex relative bg-[#F0F2F5] text-[#040435]';

  return (
    <section className={cn(baseClassName, className)} {...props}>
      {children}
    </section>
  );
}
